// This is a mixin which provides an object with the ability to set and get any kind of configuration key/value pairs from the components dataset attribute.

import {isEmpty, resolvePath} from "../../helpers/object";

export function MixinDatasetConfigurable(obj) {
    mixinMethods(obj);
}

function mixinMethods(obj) {
    Object.assign(obj.__proto__, {

        // Set our `datasetConfig` value from anything that is in the elements data attribute with the the key 'configDatasetKey'.
        setDatasetConfig(configDatasetKey) {
            this.datasetConfig = this.getDatasetConfig(configDatasetKey);
        },

        // Pass in a `configDatasetKey` that is a key for the element's dataset where we'll find a JSON string with configuration key/value pairs.
        getDatasetConfig(configDatasetKey) {
            if (typeof this.element === 'undefined' || this.element === null) return {};
            if(!this.element.dataset) return {};
            let rawData = this.element.dataset[configDatasetKey];
            if (rawData) return JSON.parse(htmlDecode(rawData));
            return {};
        },

        // Pass in a 'configKey' that is a key within the datasetConfig object.
        // The 'configKey' can be a path string to nested objects, eg. `key1.key2`.
        // We decode HTML entities in string values as often these were encoded when embedding them into an HTML data attribute.
        getDatasetConfigValue(path) {
            if (!this.hasDatasetConfig) return;
            const value = this.getDatasetConfigRawValue(path);
            if (typeof value === 'string') return htmlDecode(value);
            return value;
        },

        hasDatasetConfig() {
            return !(typeof this.datasetConfig === 'undefined' || this.datasetConfig === null || isEmpty(this.datasetConfig))
        },

        getDatasetConfigRawValue(path) {
            if (!this.hasDatasetConfig) return;
            return resolvePath(this.datasetConfig, path);
        }

    });

    function htmlDecode(input) {
        if (!input) return input;

        // Create a textarea element to decode HTML entities without stripping tags
        const textarea = document.createElement('textarea');
        textarea.innerHTML = input;

        // Return the decoded value which preserves HTML structure
        return textarea.value;
    }

}



